import React from 'react';
import BadgeBase from './BadgeBase';
import { BadgeSignals } from '../../types/TEBadgeSignal';

type NumberProps = {
  value: number;
};

function formatValue(value: number) {
  const maxValue = 99;
  return value > maxValue ? '99+' : value;
}

function isMinimumValue(value: number) {
  return value < 1;
}

const Number = ({ value, ...props }: NumberProps) => {
  if (isMinimumValue(value)) return null;
  return (
    <BadgeBase {...props} signal={BadgeSignals.Number}>
      {formatValue(value)}
    </BadgeBase>
  );
};

export default Number;
